import ertButtonComponent from './ertButton.component';

const ertButtonModule = angular.module('app.common.ertButton', [])
	.component('ertButton', ertButtonComponent)
	.name;

export default ertButtonModule;
